<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa tài khoản' : 'Thêm tài khoản'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="account_id"
            label="Tài khoản"
          >
            <el-select
              v-model="form.account_id"
              :placeholder="`Chọn tải khoản`"
              class="w-100"
              filterable
              :disabled="callingAPI || !isCreate"
              :loading="loading"
            >
              <el-option
                v-for="(account, index) in filteredAccounts"
                :key="index"
                :label="account.email"
                :value="account.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="role_id"
            label="Quyền hạn"
          >
            <el-select
              v-model="form.role_id"
              :placeholder="`Chọn quyền`"
              class="w-100"
              filterable
              :disabled="callingAPI"
              :loading="loading"
            >
              <el-option
                v-for="(role, index) in roles"
                :key="index"
                :label="role.translations && role.translations.vi ? role.translations.vi.name : role.code"
                :value="role.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { notification } from "@/utils/common";
import roleUserServices from "@/services/role-user";
import accountServices from "@/services/account";
import roleServices from "@/services/role";
import dayjs from "dayjs";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    orgInfo: Object
  },
  data() {
    return {
      loading: false,
      form: {
        account_id: "",
        role_id: "",
      },
      accountSearchText: "",
      callingAPI: false,
      accounts: [],
      roles: [],
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.id;
    },
    filteredAccounts() {
      if (this.isCreate) {
        return this.accounts.filter((i) => !i.organizations || i.organizations.length <= 0);
      }
      return this.accounts;
    },
    payloadData() {
      return {
        account_id: this.form.account_id,
        role_id: this.form.role_id,
        code: "",
        name: "",
        summary: "",
        description: "",
        extra: {},
        translation_extra: "",
        type: "",
        avatar_url: "",
        creator_id: this.item ? this.item.creator_id || "" : "",
        register_at: this.item ? this.item.register_at || dayjs() : dayjs(),
        tag_ids: this.item ? this.item.tag_ids || [] : [],
        status: this.item ? this.item.status || "" : "",
        ordered: this.item ? this.item.ordered || 0 : 0,
        organization_id: this.orgInfo.id,
      };
    },
    rules() {
      const result = {
        account_id: [
          {
            required: true,
            message: `Tài khoản là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ],
        role_id: [
          {
            required: true,
            message: `Quyền hạn là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ]
      };
      return result;
    },
  },
  beforeMount() {
    this.fetchAccounts();
    this.fetchRoles();
    this.loadFormData();
  },
  methods: {
    fetchAccounts() {
      this.loading = true;
      accountServices
        .list({
          offset: 0,
          limit: 999,
          locale: "vi",
        })
        .then((response) => {
          this.accounts = response.items;
          this.loading = false;
        })
        .catch(() => {
          this.accounts = [];
          this.loading = false;
        });
    },
    fetchRoles() {
      this.loading = true;
      roleServices
        .list({
          offset: 0,
          limit: 999,
          locale: "vi",
          filters: {
            organization_id: this.orgInfo.id
          }
        })
        .then((response) => {
          this.roles = response.items;
          this.loading = false;
        })
        .catch(() => {
          this.roles = [];
          this.loading = false;
        });
    },
    loadFormData() {
      if (this.item) {
        this.form = {
          role_id: this.item?.role_id,
          account_id: this.item?.account_id,
        };
      } else {
        this.form = {
          role_id: "",
          account_id: "",
        };
      }
    },
    remoteMethod(query) {
      this.accountSearchText = query;
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          roleUserServices[!this.isCreate ? "update" : "create"](
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
